module.exports = __webpack_public_path__ + "img/accounting-summary.d53d2b41.svg";